export default __webpack_public_path__ + "static/media/system_02_07.02af764d.jpg";